if (!customElements.get('romantic-surprise')) {
  customElements.define('romantic-surprise', class RomanticSurprise extends HTMLElement {
    constructor() {
      super();
      this.cartDrawer = document.querySelector("cart-drawer");
      this.config = JSON.parse(this.querySelector("script[type='application/json']").innerText);
    }

    connectedCallback() {
      // Get collapsible setting
      this.enableCollapsible = this.getAttribute('data-enable-collapsible') === 'true';

      // Initialize collapse functionality if enabled
      if (this.enableCollapsible) {
        this.initializeCollapse();
      }

      const surpriseOuter = this.querySelector(".surprise_selected-outer");
      this.checkbox = this.querySelector("[type=checkbox]");
      this.priceDisplay = this.querySelector(".romantic-surprise-price-display");

      if (surpriseOuter) {
        surpriseOuter.addEventListener("keydown", this.handleKeyPress.bind(this));
      }
      if (this.checkbox) {
        this.checkbox.addEventListener("change", this.handleCheckboxChange.bind(this));
        // Set initial price display state
        this.updatePriceDisplay();
      }
    }

    disconnectedCallback() {
      this.querySelector(".surprise_selected-outer").removeEventListener("keydown", this.handleKeyPress.bind(this));
      this.querySelector("[type=checkbox]").removeEventListener("change", this.handleCheckboxChange.bind(this));
    }

    handleCheckboxChange(event) {
      if (event.target.checked) {
        if (this.config.code && this.config.auto_apply_discount) fetch(`${Shopify.routes.root}discount/${this.config.code}`)
        this.querySelectorAll("input[type=hidden]").forEach((element) => {
          if (this.config.product_form_id) element.setAttribute('form', this.config.product_form_id);
        });
      } else {
        this.querySelectorAll("input[type=hidden]").forEach((element) => {
          if (element.hasAttribute("form")) element.removeAttribute("form");
        });
      }
      
      // Update price display based on checkbox state
      this.updatePriceDisplay();
    }
    
    updatePriceDisplay() {
      if (!this.priceDisplay) return;
      
      // Show price only when checkbox is checked
      if (this.checkbox && this.checkbox.checked) {
        this.priceDisplay.style.display = '';
      } else {
        this.priceDisplay.style.display = '';
      }
    }

    handleKeyPress(event) {
      console.debug(event.key);
      if (event.key === " " || event.key === "Enter") {
        event.preventDefault();
        this.querySelector(".surprise_selected-outer").click();
      }
    }

    initializeCollapse() {
      this.header = this.querySelector('.romantic-surprise-collapsible__header');
      this.content = this.querySelector('.romantic-surprise-collapsible__content');

      if (!this.header || !this.content) return;

      // Add click handler for header
      this.header.addEventListener('click', () => this.toggleCollapse());

      // Add keyboard support
      this.header.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.toggleCollapse();
        }
      });

      // Start collapsed by default
      this.isExpanded = false;
    }

    toggleCollapse() {
      this.isExpanded = !this.isExpanded;

      if (this.isExpanded) {
        this.classList.add('is-expanded');
        this.header.setAttribute('aria-expanded', 'true');
      } else {
        this.classList.remove('is-expanded');
        this.header.setAttribute('aria-expanded', 'false');
      }
    }
  });
};